import * as Yup from 'yup';
import { VALIDATORS } from 'constants/index';
import { chackAvailability } from 'graphql/utils';
import { IS_EMAIL_AVAILABLE } from 'graphql/account';

export const filterUnchangedValues = (initialValues: any, values: any) => {
  return Object.keys(values)
    .filter((vKey: string) => values[vKey] !== initialValues[vKey])
    .reduce((acc, vKey) => ({ ...acc, [vKey]: values[vKey] }), {});
};

export const filterOutTypenames = (values: any) => {
  return Object.keys(values)
    .filter((vKey: string) => vKey !== '__typename')
    .reduce((acc, vKey) => ({ ...acc, [vKey]: values[vKey] }), {});
};

export const uniqueEmailValidator = Yup.string()
  .matches(VALIDATORS.EMAIL, { message: 'Please enter a valid email.' })
  .required('Email is required.')
  .test('UniqueEmail', 'Another account with this email already exists.', async function (
    email: string,
  ) {
    if (!email || !email.match(VALIDATORS.EMAIL)) {
      throw this.createError({ message: 'Please enter a valid email.' });
    }
    try {
      const { isEmailAvailable } = await chackAvailability(IS_EMAIL_AVAILABLE, email);
      return isEmailAvailable;
    } catch (e) {
      return false;
    }
  });
